/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Deviations } from './deviations';
import { Header } from './header';
import { Footer } from './footer';
import { ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import type {
  EventReportData,
  ParsedQuestions,
  QuestionsReporData,
} from './types';

export function GoiasaDeviationsNewReport(props: { reportData: EventReportData }) {
  // We now pass the entire reportData directly into the context,
  // allowing child components to search for questions dynamically by name.
  const parsedProps: QuestionsReporData = props.reportData as any;

  return (
    <ReportContext value={parsedProps}>
      <div>
        <div
          style={{
            height: '90%',
            width: '100vw',
            flex: 1,
            backgroundColor: 'white',
            fontFamily: 'sans-serif',
          }}
        >
          <div
            style={{
              margin: '1rem auto',
              height: 'auto',
              maxWidth: '64rem',
            }}
          >
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ display: 'table-header-group' }}>
                <tr>
                  <td style={{ padding: 0, paddingBottom: '16px', paddingTop: '16px' }}>
                    <Header formName="Registro de Desvios" />
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: 0 }}>
                    <div
                      style={{
                        width: '100%',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: '#000',
                        backgroundColor: '#fff',
                        padding: '1rem',
                        borderTop: 'none', // Because Header already has a border minus bottom
                      }}
                    >
                      <InitialInfos />
                      <Deviations />
                    </div>
                  </td>
                </tr>
              </tbody>
              {/* <tfoot style={{ display: 'table-footer-group' }}>
                <tr>
                  <td style={{ padding: 0, paddingTop: '16px', paddingBottom: '24px' }}>
                    <Footer />
                  </td>
                </tr>
              </tfoot> */}
            </table>
          </div>
        </div>
      </div>
    </ReportContext>
  );
}
